import { render, staticRenderFns } from "./StudentsAutoCompleteByKey.vue?vue&type=template&id=796351e3"
import script from "./StudentsAutoCompleteByKey.vue?vue&type=script&lang=js"
export * from "./StudentsAutoCompleteByKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports